import React from "react";
import style from "../header.module.css";
import Button from 'react-bootstrap/Button';

const IntWorkshops=()=>{
  return(
  <div className={style.container}>
  
  <div >
  <hr />
  <u><b>Invitation to conduct International Workshop in ICICC-2026</b></u>
  <br />
  <br />

<p className={style.greet}>Dear Researcher/Colleagues</p>
  <p >
Greeting from ICICC-2026!<br />
<br />
ICICC Conference team invites you to organize the <span className={style.highlight}>International Workshop</span> in the <span className={style.highlight}>eighth version of International Conference on Innovative Computing and Communications (ICICC-2026)</span>, to be held at Shaheed Sukhdev College of Business Studies (University of Delhi), Sector 16, Rohini, Delh110089, India during <span className={style.highlight}>6th-7th February 2026</span> of your research domain. We are diligently working to bring some of the most knowledgeable academician from all over the world and business leaders to discuss critical research topics. The two-day conference will include a workshop, technical workshops and keynotes on our industry's cutting-edge technologies.  <br /><br /><span className={style.highlight}>The URL for the conference:</span> <a href="">icicc-conf.com</a>
<br />
<br />
By being part of this conference as a session chair and leading your own session at this esteemed conference, please increase the importance of the conference. We understand your networking skills and have an eye on identifying quality research papers.
  </p>
  </div>


    <b>Highlights of the International Workshops and Benefits:</b>
    <ul>
    

<li>All accepted papers will be published in the proceedings of ICICC-2026 (SCOPUS Indexed).</li>
<li>The workshop organizers will be entitled to receive a renumeration of 20% of the total fees collected in the workshop.</li>
<li>The minimum number of registrations should be 8 in the proposed workshop.</li>
<li>Extended papers in SCI/Scopus/ESCI/DBLP/ACM Digital Library journals. For details see <a href="">http://icicc-conf.com/publication.</a></li>
<li>High quality publishing houses are part of this conference like Springer, Elsevier, Inderscience, IEEE, Benthm Science, IGI Global and many more.</li>
<li>Special discount for your personal paper if above conditions are met. (If minimum number of papers get registered in your session)</li>
<li>Extra weightage and support will be provided for your session extended paper in SCI/ Scopus Journal.</li>
<li>Many International and National key note speakers will be delivering their lectures on latest innovative technologies in the conference.</li>
<li>Easy accessibility of the well-connected conference venue.</li>
    </ul>    
    <p>If you are interested to conduct an International Workshop, please email us the workshop proposal at <a href="mailto:icicc.ui@gmail.com">icicc.ui@gmail.com</a> with subject line as<span className={style.highlight}> “Proposal for ICICC-2026 International Workshop” </span>by 30th November 2025 as per the format given on link: <a href="">http://icicc-conf.com/call_for_international_workshops</a></p>
    <p>Looking to see you in ICICC-2026. <br /><br />

Sincerely,<br />

Organizer and Convener<br />

<b>ICICC-2026</b></p>

<Button variant="primary" > <a href={require("../Downloads/docs/Workshop_Proposal_Template.docx")} style={{color:"white",textDecoration:"none"}}>Workshop Proposal Template</a></Button>
  </div>
);
};

export default IntWorkshops;


